import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Field } from "@app/shared/field.model";
import { SearcherFieldService } from "../../services/searcher-field.service";

@Component({
  selector: "app-searcher",
  templateUrl: "./searcher.component.html",
  styleUrls: ["./searcher.component.scss"],
  providers: [SearcherFieldService],
})
export class SearcherComponent implements OnInit {
  @Input() searchFormName: string;
  @Output() searchEvent = new EventEmitter<any>();
  fields: Field<any>[];

  constructor(private searchFieldService: SearcherFieldService) {}
  ngOnInit() {
    this.fields = this.searchFieldService.getFields();
  }

  submitSearch($event) {
    this.searchEvent.emit($event);
  }
  changeSearch($event) {}
}
